// extracted by mini-css-extract-plugin
export default {"main":"AddTax_main__CaNsg","body":"AddTax_body__M1BB0","list":"AddTax_list__Afqwr","btn":"AddTax_btn__Pgn+d","header":"AddTax_header__-E1Le"};